const initialState = {
  requestingFetchJuridicalPersons: false,
  successfulFetchJuridicalPersons: false,
  errorFetchJuridicalPersons: false,
  juridicalPersons: {},
  requestingCreateJuridicalPerson: false,
  successfulCreateJuridicalPerson: false,
  errorsCreateJuridicalPerson: false,
  juridicalPerson: null,
  requestingSignatureJuridicalPerson: false,
  successfulSignatureJuridicalPerson: false,
  errorsSignatureJuridicalPerson: false,
  juridicalPersonSignature: null,
  requestingReadJuridicalPerson: false,
  successfulReadJuridicalPerson: false,
  errorsReadJuridicalPerson: false,
  rowEdited: null,
  requestingDeleteJuridicalPerson: false,
  successfulDeleteJuridicalPerson: false,
  errorsDeleteJuridicalPerson: false,
  rowDeleted: null,
  requestingUpdateJuridicalPerson: false,
  successfulUpdateJuridicalPerson: false,
  errorsUpdateJuridicalPerson: false,
  rowUpdated: null,
};

const juridicalPersonReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_JURIDICAL_PERSONS_REQUESTING":
      return {
        ...state,
        requestingFetchJuridicalPersons: true,
        successfulFetchJuridicalPersons: false,
        errorsFetchJuridicalPersons: false,
      };
    case "FETCH_JURIDICAL_PERSON_SUCCESS":
      return {
        ...state,
        errorFetchJuridicalPersons: false,
        requestingFetchJuridicalPersons: false,
        successfulFetchJuridicalPersons: true,
        juridicalPersons: action.value,
      };
    case "FETCH_JURIDICAL_PERSON_ERROR":
      return {
        ...state,
        errorFetchJuridicalPersons: true,
        requestingFetchJuridicalPersons: false,
        successfulFetchJuridicalPersons: false,
      };
    case "CREATE_JURIDICAL_PERSON_REQUESTING":
      return {
        ...state,
        requestingCreateJuridicalPerson: true,
        successfulCreateJuridicalPerson: false,
        errorsCreateJuridicalPerson: false,
      };
    case "CREATE_JURIDICAL_PERSON_SUCCESS":
      return {
        ...state,
        errorsCreateJuridicalPerson: false,
        requestingCreateJuridicalPerson: false,
        successfulCreateJuridicalPerson: true,
        juridicalPerson: action.value,
      };
    case "CREATE_JURIDICAL_PERSON_RESET":
      return {
        ...state,
        errorsCreatJuridicalPerson: false,
        requestingCreatJuridicalPerson: false,
        successfulCreatJuridicalPerson: false,
        juridicalPerson: null,
      };
    case "CREATE_JURIDICAL_PERSON_ERROR":
      return {
        ...state,
        errorsCreateJuridicalPerson: true,
        requestingCreateJuridicalPerson: false,
        successfulCreateJuridicalPerson: false,
      };
    case "SIGNATURE_JURIDICAL_PERSON_REQUESTING":
      return {
        ...state,
        requestingSignatureJuridicalPerson: true,
        successfulSignatureJuridicalPerson: false,
        errorsSignatureJuridicalPerson: false,
      };
    case "SIGNATURE_JURIDICAL_PERSON_SUCCESS":
      return {
        ...state,
        errorsSignatureJuridicalPerson: false,
        requestingSignatureJuridicalPerson: false,
        successfulSignatureJuridicalPerson: true,
        juridicalPersonSignature: action.value,
      };
    case "SIGNATURE_JURIDICAL_PERSON_RESET":
      return {
        ...state,
        errorsSignatureJuridicalPerson: false,
        requestingSignatureJuridicalPerson: false,
        successfulSignatureJuridicalPerson: false,
        juridicalPersonSignature: null,
      };
    case "SIGNATURE_JURIDICAL_PERSON_ERROR":
      return {
        ...state,
        errorsSignatureJuridicalPerson: true,
        requestingSignatureJuridicalPerson: false,
        successfulSignatureJuridicalPerson: false,
      };

    case "READ_JURIDICAL_PERSON_REQUESTING":
      return {
        ...state,
        requestingReadJuridicalPerson: true,
        successfulReadJuridicalPerson: false,
        errorsReadJuridicalPerson: false,
      };
    case "READ_JURIDICAL_PERSON_SUCCESS":
      return {
        ...state,
        errorsReadJuridicalPerson: false,
        requestingReadJuridicalPerson: false,
        successfulReadJuridicalPerson: true,
        rowEdited: action.value,
      };
    case "READ_JURIDICAL_PERSON_ERROR":
      return {
        ...state,
        errorsReadJuridicalPerson: true,
        requestingReadJuridicalPerson: false,
        successfulReadJuridicalPerson: false,
      };
    case "DELETE_JURIDICAL_PERSON_REQUESTING":
      return {
        ...state,
        requestingDeleteJuridicalPerson: true,
        successfulDeleteJuridicalPerson: false,
        errorsDeleteJuridicalPerson: false,
      };
    case "DELETE_JURIDICAL_PERSON_SUCCESS":
      return {
        ...state,
        errorsDeleteJuridicalPerson: false,
        requestingDeleteJuridicalPerson: false,
        successfulDeleteJuridicalPerson: true,
        rowDeleted: action.value,
      };
    case "DELETE_JURIDICAL_PERSON_ERROR":
      return {
        ...state,
        errorsDeleteJuridicalPerson: true,
        requestingDeleteJuridicalPerson: false,
        successfulDeleteJuridicalPerson: false,
      };
    case "UPDATE_JURIDICAL_PERSON_REQUESTING":
      return {
        ...state,
        requestingUpdateJuridicalPerson: true,
        successfulUpdateJuridicalPerson: false,
        errorsUpdateJuridicalPerson: false,
      };
    case "UPDATE_JURIDICAL_PERSON_SUCCESS":
      return {
        ...state,
        errorsUpdateJuridicalPerson: false,
        requestingUpdateJuridicalPerson: false,
        successfulUpdateJuridicalPerson: true,
        rowUpdated: action.value,
      };
    case "UPDATE_JURIDICAL_PERSON_ERROR":
      return {
        ...state,
        errorsUpdateJuridicalPerson: true,
        requestingUpdateJuridicalPerson: false,
        successfulUpdateJuridicalPerson: false,
      };
    case "RESET_JURIDICAL_PERSON_FORM":
      return {
        ...state,
        requestingCreateJuridicalPerson: false,
        successfulCreateJuridicalPerson: false,
        errorsCreateJuridicalPerson: false,
        juridicalPerson: null,
        requestingReadJuridicalPerson: false,
        successfulReadJuridicalPerson: false,
        errorsReadJuridicalPerson: false,
        rowEdited: null,
        requestingDeleteJuridicalPerson: false,
        successfulDeleteJuridicalPerson: false,
        errorsDeleteJuridicalPerson: false,
        rowDeleted: null,
        requestingUpdateJuridicalPerson: false,
        successfulUpdateJuridicalPerson: false,
        errorsUpdateJuridicalPerson: false,
        rowUpdated: null,
        requestingUpdateJuridicalPerson: false,
        successfulUpdateJuridicalPerson: false,
        errorsUpdateJuridicalPerson: false,
        rowUpdated: null,
      };
    case "RESET":
      return initialState;
    default:
      return state;
  }
};

export default juridicalPersonReducer;
